import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface StickyBottomCTAProps {
  onCTAClick: () => void;
}
export function StickyBottomCTA({
  onCTAClick
}: StickyBottomCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 500px
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-305">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-orange border-t-2 border-gold p-4 shadow-2xl md:hidden" data-id="element-306">
          <div className="max-w-md mx-auto" data-id="element-307">
            <button onClick={onCTAClick} className="w-full py-4 bg-white text-orange font-black rounded-card text-lg hover:bg-gray-100 transition-colors" data-id="element-308">
              💪 QUIERO MI VOLEY 360 AHORA
            </button>
            <p className="text-center text-white text-xs mt-2" data-id="element-309">
              🛡️ Garantía 7 días · 🔒 Pago seguro
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}